import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "container general-info-container mb-3" }
const _hoisted_2 = ["open"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 1,
  class: "text-start fs-4 fw-medium mt-2"
}
const _hoisted_6 = {
  key: 2,
  class: "text-center fw-bold fs-5 ps-0 mb-0 mt-3"
}
const _hoisted_7 = {
  id: "generalInfoForm",
  class: "inputs-grid"
}
const _hoisted_8 = ["for"]
const _hoisted_9 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 3,
  class: "d-flex flex-column mt-3"
}
const _hoisted_12 = {
  key: 1,
  class: "btn btn-primary fw-bold fs-6 col-2 mt-3 align-self-center",
  type: "button",
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("details", {
        class: "align-self-start w-100 text-start",
        open: !_ctx.sessionId
      }, [
        _cache[5] || (_cache[5] = _createElementVNode("summary", null, [
          _createElementVNode("h3", { class: "text-start fs-4 d-inline" }, "General Case Info")
        ], -1)),
        (_ctx.templates.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-start fs-4 fw-medium mt-2" }, "Choose template", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (template) => {
                return (_openBlock(), _createElementBlock("div", { key: template }, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.templateName) = $event)),
                      type: "radio",
                      value: template
                    }, null, 8, _hoisted_4), [
                      [_vModelRadio, _ctx.templateName]
                    ]),
                    _createTextVNode(" " + _toDisplayString(template), 1)
                  ])
                ]))
              }), 128))
            ]))
          : (_ctx.selectedTemplateName !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Template: " + _toDisplayString(_ctx.selectedTemplateName), 1))
            : _createCommentVNode("", true),
        (!_ctx.sessionId)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, " If necessary, fill in the blanks and change the incorrect data, then click \"Continue\" "))
          : _createCommentVNode("", true),
        _createElementVNode("form", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localInputsData, (_, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "d-flex flex-column"
            }, [
              _createElementVNode("label", {
                class: "pb-2 ps-0 fs-5 text-start fw-medium",
                for: key
              }, _toDisplayString(key), 9, _hoisted_8),
              _withDirectives(_createElementVNode("input", {
                id: key,
                "onUpdate:modelValue": ($event: any) => ((_ctx.localInputsData[key]) = $event),
                class: "p-2 fw-medium form-control",
                required: "",
                pattern: "\\S+.*",
                type: "text",
                disabled: Boolean(_ctx.sessionId)
              }, null, 8, _hoisted_9), [
                [_vModelText, _ctx.localInputsData[key]]
              ])
            ]))
          }), 128))
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "pb-2 ps-0 fs-5 text-start fw-medium mt-3" }, " Additional Info ", -1)),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localAdditionalInfo) = $event)),
            class: "w-100 text-area form-control",
            placeholder: "Provide additional information about the case",
            disabled: Boolean(_ctx.sessionId)
          }, null, 8, _hoisted_10), [
            [_vModelText, _ctx.localAdditionalInfo]
          ])
        ]),
        (!_ctx.sessionId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    form: "generalInfoForm",
                    class: "btn btn-primary fw-bold fs-6 col-2 mt-3 align-self-center",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitGeneralInfo && _ctx.submitGeneralInfo(...args)))
                  }, " Continue "))
                : (_openBlock(), _createElementBlock("button", _hoisted_12, _cache[4] || (_cache[4] = [
                    _createElementVNode("span", {
                      class: "spinner-border spinner-border-sm me-3",
                      "aria-hidden": "true"
                    }, null, -1),
                    _createElementVNode("span", { role: "status" }, "Loading...", -1)
                  ])))
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2)
    ])
  ]))
}